import "bootstrap/dist/css/bootstrap.min.css";
import * as OFMSUI from "react-bootstrap";
import $ from "jquery";
import { useFormik, FormikProvider, Field, } from "formik";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import NavigationServicesHeader from "../../../Header/NavigationServicesHeader";
import HousingService from "../../../Services/HousingService";
import { Form, Table } from "react-bootstrap";
import moment from "moment-timezone";
import { FaFastBackward } from "react-icons/fa";
import { store } from "../../../App";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const Pr_Cb = () => {
  const [TableEnable, setTableEnable] = useState(false); const [tableData1, setTableData1] = useState([]); const [distList, setDistList] = useState(); const [tableData, setTableData] = useState(); const [searchText, setSearchText] = useState(""); const [currentPage, setCurrentPage] = useState(1); const Recordsperpage = 20; const lastindex = currentPage * Recordsperpage; const firstindex = lastindex - Recordsperpage; const records = tableData?.slice(firstindex, lastindex); const npage = Math.ceil(tableData?.length / Recordsperpage); const numbers = Array.from({ length: npage }, (e, index) => index + 1); const startSerialNumber = firstindex + 1; const [loading, setLoading] = useState(false); const history = useHistory();

  React.useEffect(() => { HousingService.CGG_District().then((res) => { if (res.data) { let options = res.data.map((item, i) => { return (<option key={i} value={item.code}> {item.name} </option>); }); setDistList(options); } }); }, []);

  const todayDate = new Date(); let year = todayDate.getUTCFullYear(); let month = todayDate.getMonth() + 1; let tDate = todayDate.getDate(); if (month < 10) { month = "0" + month; } if (tDate < 10) { tDate = "0" + tDate; }
  const maxDate = year + "-" + month + "-" + tDate;




  const downloadExcel = () => {
    const excelData = [];

    excelData.push([
      `Payments and Receipts Between ${moment(
        formik.values.fromDate
      ).format("DD-MM-YYYY")} and ${moment(
        formik.values.toDate
      ).format("DD-MM-YYYY")}`,
    ]);

    excelData.push([]);

    excelData.push([
      "PAYMENTS",
      "",
      "",
      "",
      "RECEIPTS",
      "",
      "",
    ]);

    excelData.push([
      "Head ID",
      "Head Name",
      "Amount",
      "",
      "Head ID",
      "Head Name",
      "Amount",
    ]);

    const paymentRows = tableData || [];
    const receiptRows = tableData1 || [];

    const paymentTotal = paymentRows.reduce(
      (sum, item) => sum + Number(item.amount || 0),
      0
    );

    const receiptTotal = receiptRows.reduce(
      (sum, item) => sum + Number(item.amount || 0),
      0
    );

    const maxRows = Math.max(
      paymentRows.length,
      receiptRows.length
    );

    for (let i = 0; i < maxRows; i++) {
      excelData.push([
        paymentRows[i]?.headid || "",
        paymentRows[i]?.headname || "",
        paymentRows[i]?.amount || "",

        "",

        receiptRows[i]?.headid || "",
        receiptRows[i]?.headname || "",
        receiptRows[i]?.amount || "",
      ]);

      // Receipts Total immediately after receipt records end
      if (i === receiptRows.length - 1) {
        excelData.push([
          "",
          "",
          "",
          "",
          "",
          "Receipts Total",
          receiptTotal.toLocaleString("en-IN"),
        ]);
      }

      // Payments Total immediately after payment records end
      if (i === paymentRows.length - 1) {
        excelData.push([
          "",
          "Payments Total",
          paymentTotal.toLocaleString("en-IN"),
          "",
          "",
          "",
          "",
        ]);
      }
    }

    const worksheet = XLSX.utils.aoa_to_sheet(excelData);

    worksheet["!cols"] = [
      { wch: 15 },
      { wch: 40 },
      { wch: 18 },
      { wch: 5 },
      { wch: 15 },
      { wch: 40 },
      { wch: 18 },
    ];

    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(
      workbook,
      worksheet,
      "Payments_Receipts"
    );

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const data = new Blob([excelBuffer], {
      type:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    saveAs(
      data,
      `Payments_Receipts_${moment().format(
        "DDMMYYYY_HHmmss"
      )}.xlsx`
    );
  };

  const formik = useFormik({
    initialValues: { fromDate: "", toDate: "", cash_bank: "All", district: "state" },
    validate: (values) => { const errors = {}; if (!values.fromDate) { errors.fromDate = "From Date is required"; } if (!values.toDate) { errors.toDate = "To Date is required"; } if (values.fromDate && values.toDate && values.fromDate > values.toDate) { errors.toDate = "To Date must be greater than From Date"; } if (values.cash_bank === "") { errors.cash_bank = "cash_bank is required"; } if (values.district === "") { errors.district = "district is required"; } return errors; },

    onSubmit: async (values) => {
      try {
        store.dispatch({ type: "SHOW_SPINNER" });

        await new Promise((resolve) => setTimeout(resolve, 2000));

        const commonParams = {
          fromDate: moment(values.fromDate).format("DD/MM/YYYY"),
          toDate: moment(values.toDate).format("DD/MM/YYYY"),
          cash_bank: values.cash_bank,
          district: values.district,
        };
        const [paymentRes, receiptRes] = await Promise.all([
          HousingService.recieptsPayments({
            ...commonParams,
            transaction_type: "P",
          }),
          HousingService.recieptsPayments({
            ...commonParams,
            transaction_type: "R",
          }),
        ]);

        const paymentData = Array.isArray(paymentRes?.data)
          ? paymentRes.data
          : [];

        const receiptData = Array.isArray(receiptRes?.data)
          ? receiptRes.data
          : [];

        setTableData(paymentData);
        setTableData1(receiptData);

        // setTableEnable(
        //   paymentData.length > 0 || receiptData.length > 0
        // );
      } catch (error) {
        console.error("Error fetching data:", error);

        setTableData([]);
        setTableData1([]);
      } finally {
        store.dispatch({ type: "HIDE_SPINNER" });
        setTableEnable(true);

      }
    }
  });

  return (
    <>
      <NavigationServicesHeader />
      <OFMSUI.Container> <OFMSUI.Row> <OFMSUI.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className="page-titlespacing" > <div className="inner-herbpage-service-title1"> <h1 style={{ marginLeft: "-15px" }}> PAYMENTS && RECEIPTS (CASH&BANK) </h1> </div> </OFMSUI.Col> <OFMSUI.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className="page-titlespacing" > <button className="btn btn-primary btn-sm" style={{ textAlign: "right", float: "right", marginTop: "30px", backgroundColor: "#603913", borderColor: "#603913", color: "#fff" }} type="reset" onClick={() => history.goBack()} > <FaFastBackward /> &nbsp;Back </button> </OFMSUI.Col> </OFMSUI.Row>
      </OFMSUI.Container>
      <OFMSUI.Container className="outer-page-content-container">
        <FormikProvider value={formik}>
          <Form onSubmit={formik.handleSubmit}>
            <OFMSUI.Row>
              <OFMSUI.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1} ></OFMSUI.Col> <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2}>
                <th> From Date: <span className="mandatory" style={{ color: "red" }}> {" "} *{" "} </span> </th>
                <Field name="fromDate" className={formik.touched.fromDate && formik.errors.fromDate ? "form-control is-invalid" : "form-control"} type="date" onChange={(e) => formik.handleChange(e)} max={maxDate} />
                {formik.touched.fromDate && formik.errors.fromDate ? (<div className="invalid-feedback"> {formik.errors.fromDate} </div>) : null}
              </OFMSUI.Col>
              <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2}> <th> To Date: <span className="mandatory" style={{ color: "red" }}> {" "} *{" "} </span> </th>
                <Field name="toDate" className={formik.touched.toDate && formik.errors.toDate ? "form-control is-invalid" : "form-control"} type="date" onChange={(e) => formik.handleChange(e)} max={maxDate} />
                {formik.touched.toDate && formik.errors.toDate ? (<div className="invalid-feedback">{formik.errors.toDate}</div>) : null}
              </OFMSUI.Col>
              <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2}>
                <th> Cash/Bank: <span className="mandatory" style={{ color: "red" }}> {" "} *{" "} </span> </th>
                <Field name="cash_bank" component="select" onChange={(e) => formik.handleChange(e)} className={formik.touched.cash_bank && formik.errors.cash_bank ? "form-control is-invalid" : "form-control"} >
                  <option value="All">All</option>
                  <option value="Cash">Cash</option>
                  <option value="Bank">Bank</option>
                </Field>
              </OFMSUI.Col>
              <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2}>
                <th> District name <span className="mandatory" style={{ color: "red" }}> {" "} *{" "} </span> </th>
                <Field component="select" name="district" className={formik.touched.district && formik.errors.district ? "form-control is-invalid" : "form-control"} onChange={(e) => formik.handleChange(e)} > {formik.touched.district && formik.errors.district ? (<div className="invalid-feedback"> {formik.errors.district} </div>) : null}
                  <option value="state">State</option>
                  {distList} </Field>
              </OFMSUI.Col>
              <OFMSUI.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1}>
                <center> {" "} <button className="btn btn-primary btn-sm" type="submit" style={{ marginTop: "30px", backgroundColor: "#603913", borderColor: "#603913", color: "#fff" }} > Submit </button> </center>
              </OFMSUI.Col>
            </OFMSUI.Row>
            &nbsp;
            {TableEnable && (
              <>
                <OFMSUI.Row>
                  <OFMSUI.Col
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    xl={12}
                    xxl={12}
                    className="mb-2 d-flex justify-content-end"
                  >
                    <button
                      type="button"
                      className="btn btn-danger btn-sm"
                      onClick={downloadExcel}
                      style={{
                        color: "#fff",
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                      }}
                    >
                      Download
                    </button>
                  </OFMSUI.Col>
                </OFMSUI.Row>
                <div className="text-center">
                  <h6>Payments and Receipts Between {moment(formik.values.fromDate).format("DD-MM-YYYY")}  and {moment(formik.values.toDate).format("DD-MM-YYYY")} </h6>
                </div>
                <div>
                  <OFMSUI.Row>
                    <OFMSUI.Col>
                      <Table striped bordered hover id="my-table">
                        <thead className="fw-bold"> <tr> <td colSpan={3} style={{ textAlign: "center" }}> Payments </td> </tr> <tr className="table_countshead"> <th>Head ID</th> <th>Head Name</th> <th>Credit</th> </tr> </thead>
                        <tbody> {tableData?.length === 0 ? (<tr> <td colSpan={3} style={{ textAlign: "center" }}> No Details Found </td> </tr>) : (tableData?.map((tableData) => (<tr> <td>{tableData.headid} </td> <td>{tableData.headname}</td> <td className="sum">{tableData.amount}</td> </tr>)))} </tbody>

                        <tfoot> <tr className="table_countshead"> <td colSpan={2} style={{ textAlign: "center" }}> <h5>Total</h5> </td> <td> {tableData?.reduce((a, v) => a + v.amount, 0).toLocaleString("en-IN")} </td> </tr> </tfoot>
                      </Table>
                    </OFMSUI.Col>
                    <OFMSUI.Col>

                      <Table striped bordered hover id="my-table1">
                        <thead className="fw-bold"> <tr> <td colSpan={3} style={{ textAlign: "center" }}> Receipts </td> </tr> <tr className="table_countshead"> <th>Head ID</th> <th>Head Name</th> <th>Credit</th> </tr> </thead>
                        <tbody> {tableData1?.length === 0 ? (<tr> <td colSpan={3} style={{ textAlign: "center" }}> No Details Found </td> </tr>) : (tableData1?.map((tableData1) => (<tr> <td>{tableData1.headid} </td> <td>{tableData1.headname}</td> <td className="sum">{tableData1.amount}</td> </tr>)))} </tbody>
                        <tfoot> <tr className="table_countshead"> <td colSpan={2} style={{ textAlign: "center" }}> <h5>Total</h5> </td> <td> {tableData1?.reduce((a, v) => a + v.amount, 0).toLocaleString("en-IN")} </td> </tr> </tfoot>
                      </Table>
                    </OFMSUI.Col>
                  </OFMSUI.Row>
                </div>
              </>

            )}
            &nbsp;
          </Form>
        </FormikProvider>
      </OFMSUI.Container>
    </>
  );
};
export default Pr_Cb;
